import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "./api.js";
import { tilesForRole } from "./navConfig";

export default function Shell({
  title,
  children,
  rightMenu = false,
  loading = false,
  menuItems = [],
  brandClickable = true,     // already added earlier
  brandTitle,                // ⬅️ NEW: override brand text
}) {
  const [open, setOpen] = useState(false);
  const [autoMenu, setAutoMenu] = useState([]);
  const wrapRef = useRef(null);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    function onDoc(e) { if (!wrapRef.current) return; if (!wrapRef.current.contains(e.target)) setOpen(false); }
    function onKey(e) { if (e.key === "Escape") setOpen(false); }
    document.addEventListener("pointerdown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("pointerdown", onDoc); document.removeEventListener("keydown", onKey); };
  }, []);

  useEffect(() => {
    let alive = true;
    if (menuItems && menuItems.length) { setAutoMenu([]); return; }
    (async () => {
      try {
        const search = new URLSearchParams(loc.search);
        const override = search.get("role") || localStorage.getItem("roleOverride");
        if (override) { if (alive) setAutoMenu(tilesForRole(override)); return; }
        const { data } = await api.get("/api/user/role/");
        if (alive) setAutoMenu(tilesForRole(data.role));
      } catch {
        if (alive) setAutoMenu(tilesForRole("staff"));
      }
    })();
    return () => { alive = false; };
  }, [loc.search, menuItems]);

  const items = (menuItems && menuItems.length) ? menuItems : autoMenu;

  const path = loc.pathname;

  // Where we already suppress top nav
  const suppressTopNav =
    path.startsWith("/attendance/group/") || path === "/attendance/house";
  const showTopNav = rightMenu && !suppressTopNav;

  // 🔧 Default brand text: “Hugarafl” on attendance routes, otherwise “… starfsfólk”
  const defaultBrandTitle =
    suppressTopNav ? "Hugarafl" : "Hugarafl starfsfólk";
  const brandText = brandTitle || defaultBrandTitle;

  const BrandInner = (
    <>
      <div className="dash-logo" />
      <div className="dash-title">{brandText}</div>
    </>
  );

  return (
    <div className="dash-page">
      <header className="dash-header">
        {brandClickable ? (
          <Link
            to="/dashboard"
            className="dash-brand"
            aria-label={brandText}
          >
            {BrandInner}
          </Link>
        ) : (
          <div
            className="dash-brand brand-static"
            aria-label={brandText}
            style={{ cursor: "default" }}
          >
            {BrandInner}
          </div>
        )}

        {showTopNav && (
          <nav className="dash-topnav" ref={wrapRef}>
            <button
              className="topnav-link"
              aria-haspopup="menu"
              aria-expanded={open}
              onClick={() => setOpen(v => !v)}
            >
              Yfirlit ▾
            </button>

            {open && (
              <div className="menu" role="menu" aria-label="Yfirlit">
                {items.map((m) => (
                  <Link
                    key={m.to}
                    to={m.to}
                    className="menu-item"
                    role="menuitem"
                    onClick={() => setOpen(false)}
                  >
                    {m.title}
                  </Link>
                ))}
              </div>
            )}

            <button
              className="topnav-link ghost"
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("refresh");
                localStorage.removeItem("roleOverride");
                window.location.assign("/login");
              }}
            >
              Útskrá
            </button>
          </nav>
        )}
      </header>

      <main className="dash-content">
        {loading ? <div className="loading">Hleð…</div> : children}
      </main>
    </div>
  );
}